module.exports = __webpack_public_path__ + "static/media/pennypop.4b7ea63e.png";